import { IScrollablePaneStyles } from '@fluentui/react/lib/ScrollablePane';
import { ITheme } from '@fluentui/react/lib/Styling';

export function getScrollablePaneStyles(_themeName: string, _theme: ITheme) {
  return (): Partial<IScrollablePaneStyles> => {
    const styles = {
      root: {
        fontFamily: 'inherit'
      }
    };

    return styles;
  };
}
